import { render, staticRenderFns } from "./upgrade-now.vue?vue&type=template&id=363ee2f1&scoped=true"
import script from "./upgrade-now.vue?vue&type=script&lang=js"
export * from "./upgrade-now.vue?vue&type=script&lang=js"
import style0 from "./upgrade-now.vue?vue&type=style&index=0&id=363ee2f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363ee2f1",
  null
  
)

export default component.exports